import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function EventoListFilter() {
    const [filterTitulo, setFilterTitulo] = useState<FilterValuesProps>({
        property: 'dsCalendarioEvento',
        operator: 'like',
        value: '',
    });

    return (
        <Filter filters={[{ value: filterTitulo, setter: setFilterTitulo }]}>
            <Grid sx={{ flex: 1 }}>
                <CissTextField
                    label="Título"
                    value={filterTitulo.value}
                    onChange={(e) => setFilterTitulo((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
